"use client";
import * as stylex from "@stylexjs/stylex";
import { replayStyles as styles } from "../viewer/replay.styles";
import {
  type CoworldReplayFrameProps,
  type FrameLayout,
} from "./replay-frame.types";
import { frameSize } from "./replay-frame-layout";

export function ReplayStarting({
  slowStart,
  showLoadingLabel = true,
  ...layout
}: FrameLayout &
  Pick<CoworldReplayFrameProps, "showLoadingLabel"> & { slowStart: boolean }) {
  return (
    <output
      {...stylex.props(
        styles.frame,
        styles.card,
        !layout.bare && styles.bordered,
        layout.bare ? styles.page : styles.surface,
      )}
      style={frameSize(layout)}
    >
      <span {...stylex.props(styles.progress)}>
        <span aria-hidden="true" {...stylex.props(styles.spinner)} />
        <span
          {...stylex.props(
            styles.text,
            !showLoadingLabel && styles.visuallyHidden,
          )}
        >
          Starting replay...
        </span>
      </span>
      {slowStart && (
        <span
          {...stylex.props(
            styles.smallText,
            !showLoadingLabel && styles.visuallyHidden,
          )}
        >
          First load after an episode can take up to a minute while the replay
          server spins up.
        </span>
      )}
    </output>
  );
}
